var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { useErrorContext } from '../context/ErrorContext';
import { FormGroup } from './FormGroup';
import { TextField } from './TextField';
import { CountryField } from './CountryField';
export var emptyAddress = {
    line1: '',
    line2: '',
    town: '',
    postcode: '',
};
export var emptyAddressWithCountry = __assign(__assign({}, emptyAddress), { countryCode: 'GB' });
export function addressValidator(options) {
    if (options === void 0) { options = {}; }
    return function (address) {
        if (!address)
            return 'Required';
        var errors = __assign(__assign({}, emptyAddress), { countryCode: '' });
        if (!address.line1)
            errors.line1 = 'Required';
        if (options.town && !address.town)
            errors.town = 'Required';
        if (!address.postcode)
            errors.postcode = 'Required';
        if (options.country && !address.countryCode)
            errors.countryCode = 'Required';
        return Object.values(errors).find(Boolean) ? errors : null;
    };
}
export var validateAddress = addressValidator();
export var validateAddressTownRequired = addressValidator({ town: true });
export var validateAddressWithCountry = addressValidator({
    town: true,
    country: true,
});
export var AddressField = function (_a) {
    var className = _a.className, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur, showCountry = _a.showCountry, global = _a.global;
    var error = useErrorContext();
    return (jsx("div", { className: className },
        jsx(FormGroup, { controlId: "line1", error: error === null || error === void 0 ? void 0 : error.line1 },
            jsx(TextField, { id: "line1", value: (value === null || value === void 0 ? void 0 : value.line1) || '', onChange: function (e) {
                    if (!value)
                        return;
                    onChange(__assign(__assign({}, value), { line1: e.target.value }));
                }, onBlur: onBlur, variant: (error === null || error === void 0 ? void 0 : error.line1) ? 'error' : 'default', placeholder: "Line 1" })),
        jsx(FormGroup, { controlId: "line2", error: error === null || error === void 0 ? void 0 : error.line2 },
            jsx(TextField, { id: "line2", value: (value === null || value === void 0 ? void 0 : value.line2) || '', onChange: function (e) {
                    if (!value)
                        return;
                    onChange(__assign(__assign({}, value), { line2: e.target.value }));
                }, onBlur: onBlur, variant: (error === null || error === void 0 ? void 0 : error.line2) ? 'error' : 'default', placeholder: "Line 2" })),
        jsx(FormGroup, { controlId: "town", error: error === null || error === void 0 ? void 0 : error.town },
            jsx(TextField, { id: "town", value: (value === null || value === void 0 ? void 0 : value.town) || '', onChange: function (e) {
                    if (!value)
                        return;
                    onChange(__assign(__assign({}, value), { town: e.target.value }));
                }, onBlur: onBlur, variant: (error === null || error === void 0 ? void 0 : error.town) ? 'error' : 'default', placeholder: "Town" })),
        jsx(FormGroup, { controlId: "postcode", error: error === null || error === void 0 ? void 0 : error.postcode },
            jsx(TextField, { id: "postcode", value: (value === null || value === void 0 ? void 0 : value.postcode) || '', onChange: function (e) {
                    if (!value)
                        return;
                    onChange(__assign(__assign({}, value), { postcode: e.target.value }));
                }, onBlur: onBlur, variant: (error === null || error === void 0 ? void 0 : error.postcode) ? 'error' : 'default', placeholder: "Postcode", sx: { maxWidth: 150 } })),
        showCountry && (jsx(FormGroup, { controlId: "countryCode", error: error === null || error === void 0 ? void 0 : error.countryCode },
            jsx(CountryField, { id: "countryCode", value: (value === null || value === void 0 ? void 0 : value.countryCode) || '', onChange: function (countryCode) {
                    if (!value)
                        return;
                    onChange(__assign(__assign({}, value), { countryCode: countryCode }));
                }, variant: (error === null || error === void 0 ? void 0 : error.countryCode) ? 'error' : 'default', sx: { maxWidth: 250 }, global: global })))));
};
export function cleanAddress(address) {
    var _a;
    return {
        line1: address.line1.trim(),
        line2: ((_a = address.line2) === null || _a === void 0 ? void 0 : _a.trim()) || '',
        town: address.town.trim(),
        postcode: address.postcode.trim().toUpperCase(),
    };
}
//# sourceMappingURL=AddressField.js.map